import React from 'react';
import { TEXT } from '../reports/common/constants';

export class EmptyMessage extends React.Component {
  render() {
    return (
      <div className="awsui-util-t-c">
        <div className="awsui-util-pt-xs awsui-util-mb-xs">
          <b>{TEXT.EMPTY}</b>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/content/empty_message.jsx